import { render, staticRenderFns } from "./term.vue?vue&type=template&id=4618f7f0&scoped=true"
import script from "./term.vue?vue&type=script&lang=js"
export * from "./term.vue?vue&type=script&lang=js"
import style0 from "./term.vue?vue&type=style&index=0&id=4618f7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618f7f0",
  null
  
)

export default component.exports